import React from "react";


const VoucherNotice = ({ cinemaGroupName }) => {
    if (!cinemaGroupName || (cinemaGroupName.name !== "Reading" && cinemaGroupName.name !== "United Cinemas")) {
        return null;
    }

    return (
        <div className="terms-drawer__wrapper">
            <p className="terms-drawer__text terms-drawer__text--no-title">
                Please note: You are buying {cinemaGroupName.article} {cinemaGroupName.name} Voucher. It cannot be redeemed online. To secure your seat, you&#39;ll need to present the voucher(s) at the cinema&#39;s box office.
            </p>
        </div>
    );
};

export default VoucherNotice;
